import client from "../client/client";

class AiChatService {
	getAllChats({ projectId }, { page = 0, limit = 15 }, cancelToken) {
		return client.get(`/projectchat/projects/${projectId}/chats`, {
			config: { cancelToken },
			params: { page, limit },
		});
	}

	deleteChat({ projectId, chatId }, cancelToken) {
		return client.delete(`/projectchat/projects/${projectId}/chats/${chatId}`, {
			config: { cancelToken },
		});
	}

	editChatName({ projectId, chatId }, { value }, cancelToken) {
		return client.put(`/projectchat/projects/${projectId}/chats/${chatId}`, {
			payload: { value },
			config: { cancelToken },
		});
	}

	askNewQuestion({ projectId }, { value }, cancelToken) {
		return client.post(`/ai/chat/projects/${projectId}`, {
			payload: { value },
			config: { cancelToken },
		});
	}

	getChat({ projectId, chatId }, { page = 0, limit = 15 }, cancelToken) {
		return client.get(`/projectchat/projects/${projectId}/chats/${chatId}`, {
			config: { cancelToken },
			params: { page, limit },
		});
	}
}
export default new AiChatService();
